import { useUserInfo } from "@/api/user";
import { useEffect } from "react";
import { isRealNativePlatform } from "./platform";
import { setShareAuthIdentity } from "./shareAuthMirror";

/**
 * Feeds the signed-in org/account labels to the Share Extension mirror.
 *
 * Lives apart from `mirrorShareAuth` (wired up in `AuthInject`) because the
 * labels come from `/me`, and `AuthInject` is mounted above the query provider.
 * Mount this inside it instead; the mirror keeps working without it, just
 * without an identity line in the share sheet.
 *
 * Renders nothing and no-ops off native.
 */
export function ShareAuthIdentitySync() {
  const { data: userInfo } = useUserInfo();
  const orgId = userInfo?.organization?.id;
  const orgName = userInfo?.organization?.name;
  const userId = userInfo?.user?.id;
  const userEmail = userInfo?.user?.email;

  useEffect(() => {
    if (!isRealNativePlatform()) return;
    if (!orgId || !orgName || !userId || !userEmail) return;
    setShareAuthIdentity({ orgId, orgName, userId, userEmail });
  }, [orgId, orgName, userId, userEmail]);

  return null;
}
